import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} teacherType
 * @property {string} first_name - First Name of teacher
 * @property {string} last_name - Last Name of teacher
 * @property {string} email - Email of teacher
 */

/**
 * Custom hook to create new teachers in a school
 */

export const useCreateTeacher = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { axiosInstance } = useAxios();

  /**
   * @description Create a new teacher
   * @async
   * @param {teacherType[]} teachers - The teachers to be create
   * @param {()=> void} [onSuccess] - Callback function to be called on success
   * @returns {Promise<void>} Resolves once the API request completes
   */
  const createTeacher = async (teachers, onSuccess) => {
    try {
      setLoading(true);
      setError("");
      console.log("Axios Request is Working");
      const response = await axiosInstance.post(
        `${TENANT_DOMAIN}/school/admin/teacher/store`,
        {
          teachers: teachers,
        },
      );
      console.log(response);
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.log(err);
      if (err.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        const apiErrors = err?.response?.data?.errors;
        const firstError = apiErrors && Object.values(apiErrors)?.[0]?.[0];

        let errorMessage =
          firstError || err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN;

        if (
          typeof errorMessage === "string" &&
          errorMessage.match(/teachers\.\d+\.email/)
        ) {
          errorMessage =
            "The teacher email has already been taken for this school.";
        }

        setError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };
  return { loading, error, createTeacher };
};
